import { render, staticRenderFns } from "./IssueSeagoingCertificate.vue?vue&type=template&id=071cf3bc"
import script from "./IssueSeagoingCertificate.vue?vue&type=script&lang=ts"
export * from "./IssueSeagoingCertificate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports